








































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ContentHeader from "@/components/ContentHeader.vue";
import { ContentPageId, StorageKeys } from "@/main";
import * as Contentful from "contentful";
import { ContentfulClientApi } from "contentful";
import AppStorage from "@/appStorage";
import { ILoginPage } from "@/contentful/models";
import axios from "axios";
import { Document } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

interface GitResponseModel {
  checkUserLoginClubResult: boolean;
  guid: string;
}

@Component({
  components: {
    ContentHeader,
  },
  metaInfo: {
    title: "Medlemssidorna - Logga in",
  },
})
export default class Login extends Vue {
  public loading = true;
  public loggingIn = false;
  public loginError = false;
  public loginFail = false;
  public storage: AppStorage = Vue.AppStorage;
  public golfId1 = "";
  public golfId2 = "";
  public password = "";
  public keep = true;
  public content: ILoginPage | null = null;
  contentfulClient: ContentfulClientApi = Contentful.createClient({
    space: this.storage.contentfulSpace,
    accessToken: this.storage.contentfulAccessToken,
  });

  @Watch("golfId1")
  onGolfId1Changed(): void {
    if (this.golfId1.length === 6 && this.$refs.golfId2) {
      (this.$refs.golfId2 as HTMLInputElement).focus();
    }
  }

  @Watch("golfId2")
  onGolfId2Changed(): void {
    if (this.golfId2.length === 3 && this.$refs.password) {
      (this.$refs.password as HTMLInputElement).focus();
    }
  }

  mounted(): void {
    sessionStorage.removeItem(StorageKeys.Authenticated);
    const golfId: string | null = localStorage.getItem(StorageKeys.GolfId);
    if (golfId) {
      this.golfId1 = JSON.parse(golfId)[0];
      this.golfId2 = JSON.parse(golfId)[1];
    }
    if (Vue.AppStorage.loginPage) {
      this.content = Vue.AppStorage.loginPage;
      this.loading = false;
    } else {
      this.contentfulClient.getEntry(ContentPageId.Login).then((response: any) => {
        this.loading = false;
        this.content = response;
        Vue.AppStorage.loginPage = this.content;
      });
    }
  }

  htmlToString(document: Document): string {
    return documentToHtmlString(document);
  }

  login(): void {
    this.loggingIn = true;
    this.loginError = false;
    if (Vue.IsProduction) {
      axios
        .post("api/index.php", {
          username: `${this.golfId1}-${this.golfId2}`,
          password: this.password,
        })
        .then((response) => {
          const data = response.data as GitResponseModel;
          if (data.checkUserLoginClubResult) {
            if (this.keep) {
              localStorage.setItem(StorageKeys.GolfId, JSON.stringify([this.golfId1, this.golfId2]));
            } else {
              localStorage.removeItem(StorageKeys.GolfId);
            }
            sessionStorage.setItem(StorageKeys.Authenticated, data.guid);
            this.$router.push("/");
          } else {
            this.loginError = true;
          }
        })
        .catch(() => {
          this.loginFail = true;
        })
        .finally(() => {
          this.loggingIn = false;
        });
    } else {
      axios
        .get("api/index.json")
        .then((response) => {
          const data = response.data as GitResponseModel;
          if (this.keep) {
            localStorage.setItem(StorageKeys.GolfId, JSON.stringify([this.golfId1, this.golfId2]));
          } else {
            localStorage.removeItem(StorageKeys.GolfId);
          }
          sessionStorage.setItem(StorageKeys.Authenticated, data.guid);

          this.$router.push("/");
        })
        .finally(() => {
          this.loggingIn = false;
        });
    }
  }
}
